import React from 'react';
import {BrowserRouter as Router, useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import AnimatedRoutes from './components/AnimatedRoutes';
import './App.css';
import video from './assets/videos/BG.mp4';
import videomain from './assets/videos/BGMain.mp4';

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const videoSource = isHomePage ? videomain : video;

  return (
    <div className="App">
      <video
        key={videoSource} // Force re-render when video source changes
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      >
        <source src={videoSource} type="video/mp4" />
      </video>
      <motion.main
        className="main-content"
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        transition={{duration: 0.5}}
      >
        <AnimatedRoutes />
      </motion.main>
    </div>
  );
}

function App () {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
